import React from "react";

import Filter from "../Filter/Filter";
import FilterOption from "../Filter/FilterOption";

import { Check, Clock, List } from "react-feather";
import { useQueryClient } from "@tanstack/react-query";

const TodoOptions = props => {
  const { option, updateOption } = props;

  const queryClient = useQueryClient();
  const { data: todos } = queryClient.getQueryData(["todos"]);

  const todosCompleted = todos.filter(todo => todo.completed === true).length;
  const todosNotCompleted = todos.filter(todo => todo.completed === false).length;

  const hide = option === "select_all";

  return (
    <Filter>
      <FilterOption hide={hide} icon={<List size={12} />} name="todo_options" checked={true} onClick={() => updateOption("select_all")}>
        todas
      </FilterOption>

      <FilterOption icon={<Clock size={12} />} name="todo_options" onClick={() => updateOption("todo")}>
        <strong>{todosNotCompleted}</strong> a fazer
      </FilterOption>

      <FilterOption icon={<Check size={12} />} name="todo_options" onClick={() => updateOption("completed")}>
        <strong>{todosCompleted}</strong> {todosCompleted > 1 ? "concluídas" : "concluída"}
      </FilterOption>
    </Filter>
  );
}

export default TodoOptions;